import { CaseFilter } from "../../components/case-filter";
import { CTA, PageHero, SectionHeading } from "../../components/site-shell";
import { createMetadata } from "../../lib/seo";

export const metadata = createMetadata({
  title: "企业品牌增长与产品出海服务场景",
  description:
    "查看企业品牌增长与产品出海的适用场景、执行路径、服务周期和可验收交付。",
  path: "/cases",
  keywords: [
    "品牌增长案例",
    "产品出海案例",
    "企业官网案例",
    "企业网站升级案例",
    "海外独立站案例",
    "外贸网站案例",
    "SEO案例",
    "GEO优化案例",
    "AI搜索优化案例",
    "内容营销案例",
    "制造业品牌案例",
    "制造业出海案例",
    "海外询盘案例",
    "企业获客案例",
  ],
  image: "/assets/earth.jpg",
});

export default function CasesPage() {
  return (
    <>
      <PageHero
        eyebrow="Service scenarios"
        title="企业品牌增长与产品出海服务场景"
        description="从企业当前问题出发，说明适用场景、执行路径、服务周期和可验收的交付内容。"
        image="/assets/earth.jpg"
      />
      <section className="section-shell section-block-sm">
        <SectionHeading
          title="根据当前业务基础，选择合适的增长路径"
          description="以下内容依据现行服务方案整理，不展示未经客户授权的项目结果或增长数据。"
        />
        <CaseFilter />
      </section>
      <CTA
        title="从一次增长诊断开始，明确最值得优先推进的动作。"
        description="围绕品牌、网站、内容、搜索与获客路径，找准当前最影响业务增长的关键问题。"
      />
    </>
  );
}
